import { createActions, createReducer } from 'reduxsauce'

import ConsultaObrasService from '../../servicos/ConsultaObrasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaObrasInicio: [],
    buscaConsultaObrasSucesso: ['consultaObras'],
    buscaConsultaObrasErro: ['erro'],
    limpar: [],
    setConsultaObrasEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaObras = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaObrasInicio())
        let serv = new ConsultaObrasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaObrasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaObrasErro(error)))
    }
}

const buscaConsultaObrasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaObrasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaObrasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.consultaObras.resultado, dataSincronizacaoDados: action.consultaObras.dataSincronizacaoDados, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaObrasEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_OBRAS_INICIO]: buscaConsultaObrasInicio,
    [Types.BUSCA_CONSULTA_OBRAS_ERRO]: buscaConsultaObrasErro,
    [Types.BUSCA_CONSULTA_OBRAS_SUCESSO]: buscaConsultaObrasSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_OBRAS_ESTADO_DT]: setConsultaObrasEstadoDT,
})
